import React from "react";
import TruncatedListWithPopover from "../TruncatedListWithPopover";
import { formatTime, getDateString } from "../../../../utils/dateutils";
import { getFullName } from "../../../careprovider/visits/utils";

const FrequencyString = ({ careplan }) => {

  const processVisitFrequency = (frequency, frequencyPeriod) => {
    if (frequencyPeriod === "on going") {
      return [`${frequency} On Going`]
    }

    if (frequencyPeriod === "monthly") {
      const frequencyMap = new Map();

      frequency?.forEach(({ visitFrequency, months }) => {
        months.forEach((month) => {
          frequencyMap.set(month.slice(0, 3), visitFrequency);
        });
      });

      return Array.from(frequencyMap?.entries()).map(
        ([month, visitFrequency]) => `${visitFrequency} ${month}`
      );
    }

    if (frequencyPeriod === "weekly") {
      return frequency?.map(({ visitFrequency, range }) => {
        const [startTimestamp, endTimestamp] = Array.isArray(range) ? range : [];

        const startDate = getDateString(startTimestamp);
        const endDate = getDateString(endTimestamp);

        return `${visitFrequency} ${startDate} --> ${endDate}`;
      });
    }

    if (frequencyPeriod === "slot based") {
      const slotData = frequency?.[0];
      if (!slotData) return [];

      // Create list of slot assignments
      const slotAssignments = slotData?.slots?.map((slot) => {
        const start = formatTime(slot?.startTimeTimestamp, slot?.startTime);
        const end = formatTime(slot?.endTimeTimestamp, slot?.endTime);
        const timeRange = start && end ? `${start} - ${end}` : null;
        const volunteerName = getFullName(slot?.assignedVolunteer?.givenName, slot?.assignedVolunteer?.familyName) || "Unassigned";
        return `${timeRange}: ${volunteerName}`;
      }) || [];

      return slotAssignments;
    }

    return [];
  };

  const frequency = careplan?.frequency ? JSON.parse(careplan?.frequency) : [];
  const visitFrequencies = processVisitFrequency(
    frequency,
    careplan.frequencyPeriod
  );

  // Determine display settings based on frequency period
  const getDisplaySettings = () => {
    if (careplan?.frequencyPeriod === "monthly") {
      return { dataToBeDisplayed: 3, direction: "horizontal" };
    }
    if (careplan?.frequencyPeriod === "slot based") {
      return { dataToBeDisplayed: 1, direction: "vertical" };
    }
    return { dataToBeDisplayed: 1, direction: "vertical" };
  };

  const { dataToBeDisplayed, direction } = getDisplaySettings();

  return (
    <>
      <TruncatedListWithPopover
        dataList={visitFrequencies}
        dataToBeDisplayed={dataToBeDisplayed}
        direction={direction}
      />
    </>
  );
};

export default FrequencyString;
